module.exports = __webpack_public_path__ + "assets/2942c13be954ca0ae7d8ddc2506ea596.png";